import Firebase from 'firebase';

const firebaseInit = Firebase.initializeApp({
  apiKey: 'AIzaSyCsrysDf7y52xG94RjVJNuuLuPWG2ONKuo',
  authDomain: 'kanbang-d1e70.firebaseapp.com',
  databaseURL: 'https://kanbang-d1e70.firebaseio.com',
  projectId: 'kanbang-d1e70',
  storageBucket: '',
  messagingSenderId: '1038265971866',
  appId: '1:1038265971866:web:d9e98fff93195947'
});

export default firebaseInit;
